import type { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

/**
 * 提出管理のエリアタブ 1 本の状態 (AC-PSM-001)。
 *
 * - `selectable`: OCCTO マスタ登録あり ∩ 業務エリア設定。選べる
 * - `unregistered`: 集約 RPC の `areas[]` に無い (= 需要調達計画マスタのレコードが無い)。
 *   「広域マスタ未登録」
 * - `outsideBusinessAreas`: 登録はあるが業務エリア設定に無い。「業務エリア対象外」
 *
 * 両方に該当する時は `unregistered` (組織として登録されていることが根本の制約で、
 * 業務エリア設定はその上で担当者が絞り込む設定のため。AC-PSM-001 / AC-BSP-005b)。
 */
export type AreaTabAvailability =
  | 'selectable'
  | 'unregistered'
  | 'outsideBusinessAreas'

export function areaTabAvailability(
  areaCode: AreaCode,
  registeredAreaCodes: ReadonlySet<AreaCode>,
  businessAreaCodes: readonly AreaCode[],
): AreaTabAvailability {
  if (!registeredAreaCodes.has(areaCode)) {
    return 'unregistered'
  }
  return businessAreaCodes.includes(areaCode)
    ? 'selectable'
    : 'outsideBusinessAreas'
}
